import { PropsWithChildren } from "react";

type _EFMEWrapperProps = {
    breadcrumbSuper: string;
    breadcrumbTitle: string;
    pageTitle: string;
};

export type EFMEWrapperProps = PropsWithChildren<_EFMEWrapperProps>;

export default function Wrapper(props: EFMEWrapperProps): JSX.Element {
    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title"> {props.pageTitle} </h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            {props.breadcrumbSuper}
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        {props.breadcrumbTitle}
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3"></div>
                {props.children}
            </div>
        </div>
    );
}
